import * as React from 'react';
import classNames from 'classnames';
import { Link } from 'components/router/Link';

var Crumb = function Crumb(_ref) {
  var title = _ref.title,
      url = _ref.url,
      isActive = _ref.isActive;

  if (!title) {
    return null;
  }

  var renderLink = function renderLink() {
    if (isActive || !url) {
      return title;
    }

    return /*#__PURE__*/React.createElement(Link, {
      to: url
    }, title);
  };

  return /*#__PURE__*/React.createElement("li", {
    className: classNames('breadcrumb-item', {
      active: isActive
    })
  }, renderLink());
};

export default Crumb;